export * from "./announcements";
export * from "./checklist";
export * from "./localStorageVersion";
export * from "./productionChart";
export * from "./ribbon";
export * from "./silo";
export * from "./websocket";

/**
 * Basic properties of the application as they are presented on the user
 * interface.
 */
export const APP_DESCRIPTOR = {
    name: "MIL Logistics Hammerfall",
} as const;

/**
 * Whether the app is being built in production mode. This is set by
 * Webpack at bundling time. In the absence of a Webpack bundler, this
 * will evaluate to `false`.
 */
export const IS_IN_PRODUCTION_MODE = process.env.NODE_ENV === "production";

/**
 * Wheter the perspective settings menu button is enabled.
 */
export const IS_PERSPECTIVE_SETTINGS_MENU_BUTTON_ENABLED = true;

export const COMMIT_HASH_FILE_NAME = "commit-hash.txt"; // This value is also imported by the Webpack config file

export const COMMIT_HASH_CHECK_MODE: "dialog" | "fullscreen" = "dialog";

// This value is injected by the Webpack builder.
// We can not directly export a declared variable.
// This file (`constants.ts`) is also imported by the Webpack config file,
// and at that point the declared constants are not available.
declare const COMMIT_HASH: string | undefined;
const COMMIT_HASH_INJECTED_BY_WEBPACK = typeof COMMIT_HASH === "string" ? COMMIT_HASH : "unknown";
export { COMMIT_HASH_INJECTED_BY_WEBPACK as COMMIT_HASH };

// This value is injected by the Webpack builder.
// We can not directly export a declared variable.
// This file (`constants.ts`) is also imported by the Webpack config file,
// and at that point the declared constants are not available.
declare const VERSION: string | undefined;
const VERSION_INJECTED_BY_WEBPACK = typeof VERSION === "string" ? VERSION : "unknown";
export { VERSION_INJECTED_BY_WEBPACK as VERSION };

export const LOGGER_CLIENT_ID: string = process.env.LOGGING_CLIENT_ID ?? "unknown";

export const LOGGER_CONFIG_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function getRootUrlFromEnv(): string {
    const rootUrl: string | undefined = process.env.API_ROOT_URL;
    if (rootUrl === undefined) {
        throw new Error("Missing root URL environment config for the API calls.");
    }
    return rootUrl;
}
